import React, {Component} from 'react'

class GoogleSheetsGuide extends Component {
    render() {
        return (
            <div>
                {
                    'upload' in this.props ? <p>We are sorry you can't connect to your Google Sheet. Google Sheets is an independent tool and if you are seeing this message then API Spreadsheets is receiving a generic error message from Google Sheets.</p> : <p>Since Google Sheets is an independent tool that we interface with, there are a few situations where you might receive an unexpected error</p>
                }
                {
                    'upload' in this.props ? <h2>Try the following steps and you would most likely be able to connect</h2> : <p className="docsHeader">Not being able to connect to Google Sheets</p>
                }
                {
                    'upload' in this.props ? null : <p>You may not be able to connect or upload your Google Sheets at all</p>
                }
                {
                    'upload' in this.props ? <p>If you are on <b>Mobile</b> try on a Desktop</p> : <p>This is a known issue on <b>Mobile</b> browsers so try on a Desktop</p>
                }
                <p>If you are on a desktop and it's not connecting, try the following steps</p>
                <ol>
                    <li>Log out of API Spreadsheets</li>
                    <li>Clear your browser cache and cookies. <a href="https://www.a2hosting.com/kb/getting-started-guide/internet-and-networking/clearing-a-web-browsers-cache-and-cookies" target="_blank" rel="noopener noreferrer">Read here how to do that</a></li>
                    <li>Log back in to API Spreadsheets and try again</li>
                </ol>
                <br/>
                <p>If it still doesn't connect, follow the same steps as above but on a different browser</p>
                <br/>
                <p>If you are still not able to connect, you MAY have to remove your access to API Spreadsheets from your Google Account. And try again.</p>
                <ol>
                    <li>Go to your <a href="https://myaccount.google.com/" target="_blank" rel="noopener noreferrer">Google Account</a></li>
                    <li>On the left navigation panel, select <b>Security</b></li>
                    <li>On the <i>Third-party apps with account access panel</i>, select <b>Manage third-party access.</b> (you might have to scroll down a bit to see this panel)</li>
                    <li>Select <b>API Spreadsheets</b>.</li>
                    <li>Select Remove Access</li>
                    <li>Log out of <b>API Spreadsheets</b> and clear your browser <b>cache</b></li>
                    <li>Log back in to API Spreadsheets and try again</li>
                </ol>
                <br/>
                {
                    'upload' in this.props ? <p>If none of the above worked, you can contact us at <a href="mailto:info@apispreadsheets.com?Subject=Google%20Sheets%20Error%20Questions">info@apispreadsheets.com</a> and we will try to help you to the best of our ability!</p> : null
                }
                <br/>
                {
                    'upload' in this.props ? null :
                        <div>
                            <p className="docsHeader">Your Google Sheets File Deleted on Google Drive</p>
                            <p>If you delete your Google Sheet file from Google Drive and NOT from API Spreadsheets, you will get an error when you try to do anything</p>
                            <p>Your API URL will be valid but since your file does not exist, you will receive a <code>500</code> error code</p>
                            <br/>
                            <p className="docsHeader">No multiple API Spreadsheets Accounts</p>
                            <p>Each Google Account can only connect with one API Spreadsheets account</p>
                            <p>BUT you can connect to as many Google Accounts as you want from your API Spreadsheets account</p>
                            <p>For example, let's say you have three Google Accounts</p>
                            <ol>
                                <li>abc@gmail.com</li>
                                <li>xyz@gmail.com</li>
                                <li>123@gmail.com</li>
                            </ol>
                            <br/>
                            <p>And 2 API Spreadsheets accounts</p>
                            <ol>
                                <li>a123z@api.com</li>
                                <li>b789c@api.com</li>
                            </ol>
                            <br/>
                            <p>You can connect <b>abc@gmail.com</b> and <b>xyz@gmail.com</b> to <b style={{color: "green"}}>a123z@api.com</b></p>
                            <p>BUT if you try to also connect <b>abc@gmail.com</b> to <b style={{color: "red"}}>b789c@api.com</b></p>
                            <p><b>You will receive an ERROR and not be able to proceed</b></p>
                            <br/>
                            <p className="docsHeader">Operation timed out</p>
                            <p>Sometimes if you do a heavy request of reading or writing multi thousand rows, Google Sheets times out</p>
                            <p>This is not related to anything particular and often happens at random due to Google Sheets</p>
                            <p>If you are unable to execute your request, wait a bit and try again!</p>
                            <br/><br/><br/>
                        </div>
                }
            </div>
        )
    }
}

export default GoogleSheetsGuide